import Cookies from 'js-cookie';
//import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, H1, FormGroup, InputGroup, Toaster } from '@blueprintjs/core';
import {  FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, 
  FRONT_USER_PASSWORD_IN_COOKIE_NAME,
  FRONT_USER_FIRST_NAME_COOKIE_NAME,
  FRONT_USER_LAST_NAME_COOKIE_NAME,
  FRONT_USER_AFFILIATION_COOKIE_NAME,
  FRONT_USER_STATUS_COOKIE_NAME,
  FRONT_USER_EMAIL_COOKIE_NAME,
  FRONT_USER_COUNTRY_COOKIE_NAME,
} from '../auth/constants';

import EnhancedSingleSelect from '../common/EnhancedSingleSelect';
import './CommonAuth.css';


class PersonalData extends React.PureComponent {

  refHandlers = {
    toaster: (ref) => this.toaster = ref,
  };



  state = {
    login: Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME),
    currentPassword: Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME),
    password: Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME),
    password2:Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME),
    firstname:  Cookies.get(FRONT_USER_FIRST_NAME_COOKIE_NAME),
    name:  Cookies.get(FRONT_USER_LAST_NAME_COOKIE_NAME),
    email:  Cookies.get(FRONT_USER_EMAIL_COOKIE_NAME),
    status:  Cookies.get(FRONT_USER_STATUS_COOKIE_NAME),
    affiliation:  Cookies.get(FRONT_USER_AFFILIATION_COOKIE_NAME),
    country:  Cookies.get(FRONT_USER_COUNTRY_COOKIE_NAME),
  };

  addMissingFieldsToast = () => {
    this.toaster.show({
      message: this.props.t('addMissingFieldsMsg'),
      intent: 'warning',
      icon: 'hand',
    });
  }

  addErrorToast = () => {
    this.toaster.show({
      message: this.props.t('addErrorMsg'),
      intent: 'danger',
      icon: 'warning-sign',
    });
  }
  addDifferentPasswordToast = () => {
    this.toaster.show({
      message: this.props.t('differentPasswordMsg'),
      intent: 'danger',
      icon: 'warning-sign',
    });
  }

  addValidateFormToast = () => {
    this.toaster.show({
      message: this.props.t('dataUpdated'),
      intent: 'success',
      icon: 'tick',
    });
  }

  validateForm = (e) => {
    e.preventDefault();

    // make sure no empty fields
    const userValues = Object.values(this.state);
    if (userValues.includes('')) {
      this.addMissingFieldsToast();
      return;
    }
    if (userValues.password !== userValues.password2) {
        this.addDifferentPasswordToast();
        return;
    }

    const bodyData = { ...this.state };

    const endpoint = '/updatePersonalData.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
    })
    .then((res) => {
      if (res.status === 400) {  // if unidentified issue
        this.addErrorToast();
      } else {  // if it worked
        this.addValidateFormToast();
      }
    })
    .catch(() => {
      console.log(`Network error when trying to fetch ${endpoint}`);
    })
  }

  onTextUpdate = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    this.setState({ [id]: value });
  }

  render() {
    const { affiliation, country, email, firstname, login, name, password, password2, status  } = this.state;
    const { t } = this.props;
    const isUserFrontLoggedIn = !!(Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME));


    const statusOptions = [
      t('scholar'),
      t('teachingScholar'),
      t('FFLTeacher'),
      t('phdStudent'),
      t('student'),
      t('other'),
    ];

    return (
      <div className="CommonAuth__wrapper">
        <H1>{t('personalData')}</H1>

        { isUserFrontLoggedIn && 
            <form onSubmit={this.validateForm} className="margin-top-2-rem">
            <FormGroup label={t('name')} labelFor="name">
                <InputGroup id="name" type="text" value={name} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('firstName')} labelFor="firstname">
                <InputGroup id="firstname" type="text" value={firstname} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('affiliation')} labelFor="affiliation">
                <InputGroup id="affiliation" type="text" value={affiliation} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('country')} labelFor="country">
                <InputGroup id="country" type="text" value={country} onChange={this.onTextUpdate} />
            </FormGroup>

            <EnhancedSingleSelect
                label={t('status')}
                name='status'  // name is also used to make the input's `id`
                hasDefault={true}
                hasSelectableDefault={false}
                options={statusOptions}
                value={status}
                onChange={this.onTextUpdate}
            />

            <FormGroup label={t('email')} labelFor="email">
                <InputGroup id="email" type="email" value={email} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('logIn')+" - "+t('noSpaceNoSpecialChar')} labelFor="login">
                <InputGroup id="login" type="text" value={login} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('password')} labelFor="password" >
                <InputGroup id="password" type="password" value={password} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('passwordConfirmation')} labelFor="password2" >
                <InputGroup id="password2" type="password" value={password2} onChange={this.onTextUpdate} />
            </FormGroup>


            <Button type="submit" intent='primary'>Ok</Button>
            </form>
        }

        { ! isUserFrontLoggedIn &&
             <p className="margin-top-2-rem">{t('youMustLogInToAccessThisPage')}</p>
        }

        <p className="margin-top-2-rem">{t('detailedDataPolicy')}</p>

        {/* Special component, out of the normal flow */}
        <Toaster ref={this.refHandlers.toaster} />
      </div>
    );
  }
}

PersonalData.propTypes = {

};

export default withTranslation()(PersonalData);
